module.exports = __webpack_public_path__ + "static/media/nervosity-spectrum.ce1401e8.png";